import script from "./grvPage.vue?vue&type=script&setup=true&lang=js"
export * from "./grvPage.vue?vue&type=script&setup=true&lang=js"

import "./grvPage.vue?vue&type=style&index=0&id=97a6f7fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97a6f7fc"]])

export default __exports__